import produce from 'immer';
import {
  FETCH_CONTENT_FAILURE,
  FETCH_CONTENT_SUCCESS,
  FILTER_CONTENT,
  HIDE_CONTENT_SUCCESS,
  UNHIDE_CONTENT_SUCCESS,
} from './constants';

export const initialState = {
  data: [],
  fetched: false,
};

const shareLinksReducer = (state = initialState, { type, payload }) =>
  produce(state, draft => {
    switch (type) {
      case FETCH_CONTENT_SUCCESS: {
        draft.data = payload;
        draft.fetched = true;
        break;
      }
      case FILTER_CONTENT: {
        const { uid } = payload;
        draft.data = draft.data.filter(item => item.uid !== uid);
        break;
      }
      case FETCH_CONTENT_FAILURE: {
        draft.data = [];
        draft.fetched = false;
        break;
      }
      case HIDE_CONTENT_SUCCESS: {
        const { uid } = payload;
        draft.data.map(item => {
          if (item.uid === uid) {
            item.is_hidden = true;
          }
          return item;
        });
        break;
      }
      case UNHIDE_CONTENT_SUCCESS: {
        const { uid } = payload;
        draft.data.map(item => {
          if (item.uid === uid) {
            item.is_hidden = false;
          }
          return item;
        });
        break;
      }
      default:
        break;
    }
  });

export default shareLinksReducer;
